export default __webpack_public_path__ + "static/media/Back.da528c52.png";